module.exports = __webpack_public_path__ + "a7ec344341d72a7e1f132b11d6119323.svg";